import { HttpHeaders } from '@angular/common/http';
import { EdocBrands } from '../../header/navigation-book/navigation-book.model';
import {
  SavedSearchAPIRequest,
  SavedSearchFlags,
  SavedSearchGQLRequest
} from '../../model/saved-search/saved-search.interface';

export const createRequest = (
  token: string,
  saveSearchRequest: SavedSearchGQLRequest
): SavedSearchAPIRequest => {
  let headers = new HttpHeaders();
  headers = headers.append('Content-Type', 'application/json');
  headers = headers.append('Sub', saveSearchRequest.customerId);
  headers = headers.append('Authorization', `Bearer ${token}`);
  const endPoint = saveSearchRequest.endPoint;
  const brands = saveSearchRequest.brands;
  const body = `{
          saved_searches {
            cabin
            destination_city
            origin_city
            passenger_count
            trip_alias
            trip_reason
          }
        }`;
  return { headers, body, endPoint, brands };
};

export const isGQLEnabled = (flags: SavedSearchFlags): boolean => {
  return flags.gql && flags.config;
};

export const getSavedSearchGQLRequest = (
  custId: string,
  brands: EdocBrands[],
  endPoint: string
): SavedSearchGQLRequest => {
  let savedSearchRequest = {
    customerId: custId,
    brands: brands,
    endPoint: endPoint
  };
  return savedSearchRequest;
};
